<div class="body">
  <div class="login-bg" aria-hidden="true">
    <div class="login-orb login-orb-1"></div>
    <div class="login-orb login-orb-2"></div>
    <div class="login-orb login-orb-3"></div>
  </div>

  <div class="login-container">
    <!-- Left side brand panel -->
    <div class="login-brand" aria-label="Handle — Finally, a Handle on guidance.">
      <img src="assets/logos/SVG/Handle_Vert_Logo.svg" alt="Handle" class="app-logo-img" />
      <div class="brand-tagline" aria-hidden="true">Finally, a Handle<br />on guidance.</div>
      <ul class="brand-features" aria-label="Features">
        <li class="brand-feature">
          <div class="brand-feature-dot" aria-hidden="true"></div>
          <span>Build your career profile</span>
        </li>
        <li class="brand-feature">
          <div class="brand-feature-dot" aria-hidden="true"></div>
          <span>Connect with mentors</span>
        </li>
        <li class="brand-feature">
          <div class="brand-feature-dot" aria-hidden="true"></div>
          <span>Discover opportunities</span>
        </li>
      </ul>
    </div>

    <!-- Right side card -->
    <div class="login-card">
      <div class="login-card-inner">
        <h1 class="login-title">Welcome back</h1>
        <p class="login-sub">Sign in to continue your journey.</p>

        <a href="/login" aria-label="Sign in with Google">
          <button mat-flat-button class="login-btn" aria-label="Sign in with Google">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              class="google-icon"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                fill="#4285F4"
              />
              <path
                d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"
                fill="#34A853"
              />
              <path
                d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                fill="#FBBC05"
              />
              <path
                d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"
                fill="#EA4335"
              />
            </svg>
            Sign in with Google
          </button>
        </a>

        <div class="login-divider" aria-hidden="true">
          <mat-divider></mat-divider>
          <span>or</span>
          <mat-divider></mat-divider>
        </div>

        <p class="back-link">
          Don't have an account?
          <a routerLink="/register" aria-label="Register for a new account">Register</a>
        </p>
      </div>
    </div>
  </div>
</div>
